<template>
  <div
    class="profile-owl-carousel__img show profile-card__image"
    v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + ')'}"
  >
    <div v-if="enabled">
      <OwlCarousel :items="1" :mouseDrag="false" :touchDrag="false" :pullDrag="false" :freeDrag="false">
        <div v-for="src in mediaUrls">
          <ProfileCard :profile="profile" :src="src" :showProfileDetails="showProfileDetails"></ProfileCard>
        </div>
      </OwlCarousel>
    </div>
  </div>
</template>

<script>
import OwlCarousel from '../../modules/OwlCarousel';
import ProfileCard from './ProfileCard';
import ProfileDetails from './ProfileDetails';

export default {
  name: 'DraggableProfileCard',
  components: { ProfileCard, OwlCarousel, ProfileDetails },
  props: {
    profile: Object,
    showProfileDetails: Boolean,
  },
  data() {
    return {
      enabled: false,
      mediaUrls: [],
    };
  },
  watch: {
    'profile.id': function (newVal) {
      this.setOwlCarousel();
    },
  },
  methods: {
    setOwlCarousel() {
      let vm = this;
      vm.enabled = false;
      vm.mediaUrls = [];
      // vm.mediaUrls.push(vm.profile.avatar_url);
      vm.profile.media.forEach((media) => {
        vm.mediaUrls.push(media.url);
      });

      setTimeout(function () {
        vm.enabled = true;
      }, 200);
    }
  },
  mounted() {
    this.setOwlCarousel();
  }
};
</script>


